"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const views_1 = require("../core/views");
const core_1 = require("../types/core");
class SalesApp {
    constructor(axiosInstance) {
        this.sales = new SaleModule(axiosInstance);
        this.virtualCards = new VirtualCardModule(axiosInstance);
    }
}
class SaleModule extends views_1.ListCreateView {
    constructor() {
        super(...arguments);
        this.endpoint = "/api/v1/sales/";
    }
    listStoreSales(storeId) {
        return this._list(1, {}, core_1.PartiuRole.pdv, storeId);
    }
    createStoreSale(storeId, data) {
        return this._create(data, core_1.PartiuRole.pdv, storeId);
    }
    summary(month, year) {
        return this.axiosInstance
            .post(this.endpoint + "summary/", { month, year })
            .then(({ data }) => data);
    }
}
class VirtualCardModule extends views_1.ListCreateView {
    constructor() {
        super(...arguments);
        this.endpoint = "/api/v1/virtual-cards/";
        this.create = (discountId, role = core_1.PartiuRole.user) => {
            return this._create({ discount_id: discountId }, role);
        };
    }
    listStoreVirtualCards(storeId) {
        return this._list(1, {}, core_1.PartiuRole.pdv, storeId);
    }
}
exports.default = SalesApp;
//# sourceMappingURL=sales.js.map